import React, { Component, useState, useEffect } from "react";
import HeaderModern from "../components/header/HeaderModern";
import GreetingModern from "./greeting/GreetingModern";
import SkillsModern from "./skills/SkillsModern";
import SkillProgressModern from "./skillProgress/SkillProgressModern";
import WorkExperienceModern from "./workExperience/WorkExperienceModern";
import ProjectsModern from "./projects/ProjectsModern";
import StartupProjectModern from "./StartupProjects/StartupProjectModern";
import AchievementModern from "./achievement/AchievementModern";
import BlogsModern from "./blogs/BlogsModern";
import FooterModern from "../components/footer/FooterModern";
import EducationModern from "./education/EducationModern";
import ContactModern from "./contact/ContactModern";
import Top from "./topbutton/Top";
import Twitter from "./twitter-embed/twitter";
import { StyleProvider } from "../contexts/StyleContext";
import "./Main.css";
import SplashScreen from "./splashScreen/SplashScreen";
import {splashScreen} from "../portfolio";



const Main = () => {
  const [isDark, setIsDark] = useState(true);
  const [isShowingSplashAnimation, setIsShowingSplashAnimation] =
    useState(true);

  useEffect(() => {
    if (splashScreen.enabled) {
      const splashTimer = setTimeout(
        () => setIsShowingSplashAnimation(false),
        splashScreen.duration
      );
      return () => {
        clearTimeout(splashTimer);
      };
    }
  }, []);

  const changeTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className={isDark ? "dark" : ""}>
      <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
        {isShowingSplashAnimation && splashScreen.enabled ? (
          <SplashScreen />
        ) : (
          <>
           <HeaderModern />
          <GreetingModern />
          <SkillsModern />
          <SkillProgressModern />
          <WorkExperienceModern />
          <EducationModern />
          <ProjectsModern />
          <StartupProjectModern />
          <AchievementModern />
          <BlogsModern />
          {/* <Talks /> */}
          {/* <Twitter /> - Temporarily disabled due to React 19 incompatibility */}
          {/* <Podcast /> */}
          <ContactModern />
          <FooterModern />
          <Top />
          </>
        )}
      </StyleProvider>
    </div>
  );
};

export default Main;
